// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React /* eslint-disable-line no-unused-vars */, {
  Fragment,
  type Node,
} from 'react';

import TrialWelcomeModalHeader from '@zapier/design-system-company/src/components/TrialWelcomeModalHeader';
import { LoadableImg } from '@zapier/design-system-microlibrary-shared';
import {
  Button,
  Colors,
  Heading,
  Margin,
  Spacer,
  Text,
  Typography,
} from '@zapier/design-system';
import {
  isolateComponent,
  labelStyles,
  responsiveStyles,
} from '@zapier/common-utils';

import { type Size } from '@zapier/design-system-company/src/types';

/** @jsx isolateComponent */

type Props = {
  /** The main content of the topic */
  children: Node,
  /** The href of the Setup link */
  href: string,
  /** Image alt text */
  imageAlt: string,
  /** Image source */
  imageSrc: string,
  /** Callback to be executed when the modal is closed */
  onClose: () => void,
  /** Callback to be executed when the button is clicked */
  onRoute: string => void,
  /** Size */
  size: Size,
  /** Content title */
  title: string,
};

const Styles = labelStyles(__filename, {
  buttonWrapper: size =>
    responsiveStyles(size, {
      small: {
        display: 'grid',
        gridGap: 10,
      },
      medium: {
        display: 'flex',
        justifyContent: 'space-between',
      },
    }),

  heading: {
    ...Typography.subtitle900,
    color: Colors.grey900,
  },
});

const TrialWelcomeModalTopicView = (props: Props) => (
  <Fragment>
    <TrialWelcomeModalHeader trimChildren={true}>
      <LoadableImg
        alt={props.imageAlt}
        aspectRatio="440:260"
        hasRadius={false}
        src={props.imageSrc}
      />
    </TrialWelcomeModalHeader>

    <Margin margin={props.size === 'small' ? 20 : 40}>
      <Heading css={Styles.heading}>{props.title}</Heading>

      <Spacer height={25} />

      <Text color="grey900" tag="p" type="bodyText900">
        {props.children}
      </Text>

      <Spacer height={20} />

      <div css={Styles.buttonWrapper(props.size)}>
        <Button color="grey" onClick={() => props.onRoute('guide')}>
          Back
        </Button>

        <Button
          color="black"
          hasShadow={true}
          href={props.href}
          onClick={() => props.onClose()}
        >
          Setup
        </Button>
      </div>
    </Margin>
  </Fragment>
);

export default TrialWelcomeModalTopicView;
